import React, { ReactNode, useState } from 'react'

import classNames from 'classnames'
import { Dropdown, IconBottom } from 'shared/components'

import classes from './SelectDropDown.module.scss'

type Props<T> = {
  options: T[]
  value: T
  dropDownRight?: boolean
  onClick: (value: T) => void
  renderOption: (value: T) => ReactNode
}
export function SelectDropdown<T>({
  options,
  value,
  dropDownRight,
  onClick,
  renderOption,
}: Props<T>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (value: T) => {
    setIsOpen(false)
    onClick(value)
  }

  const renderText = () => {
    return (
      <>
        <span className={classes.sort}>Сортировать по: </span>
        <span className="link color">{renderOption(value)}</span>
      </>
    )
  }

  return (
    <div className={classes.sort_container}>
      <IconBottom
        openText={renderText()}
        closeText={renderText()}
        isOpen={isOpen}
        onClick={() => setIsOpen(true)}
        className={classes.dropdown}
      >
        <Dropdown
          isMenuVisible={isOpen}
          outSideClick={() => setIsOpen(false)}
          right={dropDownRight}
        >
          {options.map((sort, sortKey) => {
            const isActive = value === sort
            const cn = classNames([
              classes.sort_item,
              { [classes.active]: isActive },
            ])
            return (
              <div
                className={cn}
                key={sortKey}
                onClick={() => handleClick(sort)}
              >
                {renderOption(sort)}
                {isActive && <i className="icon-check"></i>}
              </div>
            )
          })}
        </Dropdown>
      </IconBottom>
    </div>
  )
}
